import { render, staticRenderFns } from "./autocomplete-program-category.vue?vue&type=template&id=e8309cb2&"
import script from "./autocomplete-program-category.vue?vue&type=script&lang=js&"
export * from "./autocomplete-program-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports